var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9995 12.2304V14.4885C16.0004 14.6981 15.9574 14.9056 15.8732 15.0977C15.7891 15.2898 15.6657 15.4622 15.5109 15.6039C15.3561 15.7456 15.1734 15.8535 14.9744 15.9207C14.7754 15.9878 14.5646 16.0128 14.3554 15.9939C12.0346 15.7422 9.80532 14.9508 7.84668 13.6831C6.02441 12.5274 4.47945 10.9855 3.3215 9.16689C2.0469 7.20324 1.25368 4.96756 1.00612 2.64096C0.987275 2.43282 1.01206 2.22303 1.0789 2.02497C1.14574 1.82691 1.25317 1.6449 1.39436 1.49055C1.53554 1.33619 1.70738 1.21287 1.89893 1.12843C2.09049 1.04398 2.29756 1.00027 2.50697 1.00007H4.76956C5.13558 0.996478 5.49041 1.12583 5.76793 1.36403C6.04546 1.60222 6.22672 1.93301 6.27795 2.29472C6.37345 3.01736 6.55055 3.72691 6.80589 4.40981C6.90736 4.67922 6.92932 4.97202 6.86917 5.2535C6.80902 5.53498 6.66928 5.79336 6.4665 5.99801L5.50867 6.95394C6.58231 8.83837 8.14568 10.3986 10.0338 11.4702L10.9917 10.5142C11.1967 10.3118 11.4556 10.1724 11.7377 10.1123C12.0197 10.0523 12.3131 10.0742 12.583 10.1755C13.2673 10.4303 13.9782 10.6071 14.7023 10.7024C15.0687 10.754 15.4033 10.9381 15.6424 11.2199C15.8816 11.5016 16.0087 11.8612 15.9995 12.2304Z",
    stroke: "#425364",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.d6cd6f15cd1e3a637508ca144abf4dae.svg";
export { ForwardRef as ReactComponent };